/* global __HOT__ */
import { nodelistToArray } from './helpers/nodelistToArray'
import { uuid } from './helpers/uuid'

export function init (rootElementClassName, mountFn, callbackFn) {
  findElements(rootElementClassName).forEach(el => {
    el.id = uuid()
    window[rootElementClassName][el.id] = true

    // Extract preloaded state sent person server
    mountFn(el)

    // Enable webpack hot-reloading
    if (__HOT__) {
      // Reload CSS file

      require('webpack/hot/emitter').on('webpackHotUpdate', currentHash => {
        document.querySelectorAll('link[href][rel=stylesheet]').forEach(link => {
          const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`)
          link.href = nextStyleHref
        })
      })

      // Reload and re-render React application
      module.hot.accept('./index', () => {
        const { ReactDOM } = require('react')
        ReactDOM.hydrate(require('../shared/App').default, el)
      })
    }
  })
}

function findElements (rootElementClassName) {
  return nodelistToArray(document.getElementsByClassName(rootElementClassName)).filter(
    el => !isInitialized(el, rootElementClassName)
  )
}

function isInitialized (el, rootElementClassName) {
  return el.id && window[rootElementClassName][el.id]
}



// WEBPACK FOOTER //
// ./src/client/init.js